import { render } from "./TimerSpinner.vue?vue&type=template&id=1c3b06b8&scoped=true"
const script = {}

import "./TimerSpinner.vue?vue&type=style&index=0&id=1c3b06b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c3b06b8"

export default script